class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    $("#cart-notification").css("opacity","0");
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          var viid = $(".product-form form input[name='id']").val();
          console.log(viid);
          var nehtml = '';
          for (var i = 0; i < cart.items.length; i++) {
            // if(cart.items[i].id == viid){
              var imgs = cart.items[i].image;
              var ttl = cart.items[i].title;
               nehtml += '<div id="shopify-section-cart-notification-product" class="shopify-section"><div class="cart-item"><div class="cart-notification-product__image global-media-settings"><img src="'+imgs+'" alt="" width="70" height="70" loading="lazy"></div><div><h3 class="cart-notification-product__name h4">'+ttl+'</h3><dl></dl></div></div></div>';

            // }
          }
          
          $("#cart-notification-product").html(nehtml);
          $("#cart-notification").css("opacity","1");
            var url = window.location.href;
            var result = url.includes("deluxe-public-work-stand");
            if(result == true){
            var counter = 0;
          for (var i = 0; i < cart.items.length; i++) {
             if(cart.items[i].product_id == 8296694808790){
               counter +=cart.items[i].quantity;
             }
            }
              $(".cnt-prd").attr("data-number",counter);
           if(counter > 2){
             $(".cnt-prd").show();
             $(".product-form__submit").addClass("disabled-btn");
           }
           else{
          $(".cnt-prd").hide();
          $(".product-form__submit").removeClass("disabled-btn");
           }   
            }
          var chg_ln = $(".mns-deluxe-public-work-stand").length;
          if(chg_ln > 0 ){
             var counter = 0;
          for (var i = 0; i < cart.items.length; i++) {
             if(cart.items[i].product_id == 8296694808790){
               counter +=cart.items[i].quantity;
             }
            }
            if(counter > 2){
             $(".cnt-prd").show();
             $(".mns-deluxe-public-work-stand").addClass("hidden-product-deluxe-public-work-stand");
           }
           else{
          $(".cnt-prd").hide();
          $(".mns-deluxe-public-work-stand").removeClass("hidden-product-deluxe-public-work-stand");
           }   

          }


            
        }
    });
      $.ajax({
        type: 'GET',
        url: '/',
        cache: false,
        dataType: 'html',
        success: function(cart) {
          var fhtml = $(cart).find(".cart_counter").html();
          $(".cart_counter").html(fhtml);
            var fhtml = $(cart).find("#cart-icon-bubble").html();
          $("#cart-icon-bubble").html(fhtml);
        }
    });
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    console.log(selector);
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
